import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../scss/screen.scss';
import './utils/i18nConfig';
import axios from 'axios';
import { SWRConfig } from 'swr';
import Heatpump from './Heatpump';
import axiosConfig from './utils/axiosConfig';

axiosConfig();

createRoot(document.getElementById('root')!).render(
    <SWRConfig
        value={{
            dedupingInterval: 5000, // ignores additional calls with the same key (prevents hammering)
            shouldRetryOnError: false,
            fetcher: (url) =>
                axios
                    .get(url)
                    .then((res) => res.data)
                    .catch((error) => {
                        throw new Error(error);
                    }),
        }}
    >
        <StrictMode>
            <Heatpump />
        </StrictMode>
    </SWRConfig>
);
